import styles from "./ShortcutBar.styled";

export const tooltipStyles = {
  tooltip: {
    sx: styles.tooltip,
  },
  arrow: {
    sx: styles.tooltipArrow,
  },
};
